import { render, staticRenderFns } from "./shopLabel.vue?vue&type=template&id=42c1a1f1&scoped=true"
import script from "./shopLabel.vue?vue&type=script&lang=js"
export * from "./shopLabel.vue?vue&type=script&lang=js"
import style0 from "./shopLabel.vue?vue&type=style&index=0&id=42c1a1f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c1a1f1",
  null
  
)

export default component.exports